import { render, staticRenderFns } from "./SocialCampaignDialog.vue?vue&type=template&id=5ccc61f7&scoped=true&"
import script from "./SocialCampaignDialog.vue?vue&type=script&lang=js&"
export * from "./SocialCampaignDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialCampaignDialog.vue?vue&type=style&index=0&id=5ccc61f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc61f7",
  null
  
)

export default component.exports